/* MentionInternal.tsx generated by @compiled/babel-plugin v3.0.2 */
/* eslint-disable @atlaskit/design-system/no-deprecated-imports, @typescript-eslint/no-empty-object-type, @typescript-eslint/no-wrapper-object-types -- Preserve existing mention implementation while focus-ring usage is reviewed separately. */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDS5Zs%7Bborder-radius%3Avar(--ds-radius-full%2C9999px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbccYA%7Bdisplay%3Ainline-flex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02R4Xu%7Bwidth%3A1em%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VR4Xu%7Bheight%3A1em%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuDIqT%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2xTnZx1Y8M%7Bmargin-inline-end%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1RrJLiVdJo%7Bvertical-align%3A-.125em%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDdnbC%7Bborder-radius%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1uo2ZfnV0Y%7Bclip-path%3Apolygon(25%25%206.7%25%2C75%25%206.7%25%2C100%25%2050%25%2C75%25%2093.3%25%2C25%25%2093.3%25%2C0%2050%25)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1RrJLixiOt%7Bvertical-align%3A.05em%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbvLZJ%7Bdisplay%3Ablock%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VN91d%7Bheight%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._00EA0eiObl%7B-o-object-fit%3Acover%3Bobject-fit%3Acover%7D");
import React from 'react';
import FocusRing from '@atlaskit/focus-ring/focus-ring';
import { UFOExperienceState } from '@atlaskit/ufo/experience-state';
import { UNKNOWN_USER_ID } from '../../_constants';
import { isRestricted } from '../../is-restricted';
import { MentionType } from '../../types';
import { UnknownUserError } from '../../util/i18n';
import AsyncDisabledMentionTooltip from '../DisabledMentionTooltip';
import MessagesIntlProvider from '../MessagesIntlProvider';
import AsyncNoAccessTooltip from '../NoAccessTooltip';
import { ANALYTICS_HOVER_DELAY } from './index';
import type { Props } from './index';
import PrimitiveMention from './PrimitiveMention';
import { UfoErrorBoundary, mentionRenderedUfoExperience } from './ufoExperiences';
const avatarStyles = null;
const avatarFallbackStyles = null;
const avatarImageStyles = null;
const agentAvatarStyles = null;
type State = {
  avatarUrl?: string;
  hasAvatarError: boolean;
};
export class MentionInternal extends React.PureComponent<Props, State> {
  private hoverTimeout?: number;
  state: State = {
    hasAvatarError: false
  };
  constructor(props: Props) {
    super(props);
    mentionRenderedUfoExperience.getInstance(props.id).start();
  }
  componentDidMount(): void {
    mentionRenderedUfoExperience.getInstance(this.props.id).success();
  }
  static getDerivedStateFromProps(props: Props, state: State): Partial<State> | null {
    if (props.avatarUrl !== state.avatarUrl) {
      return {
        avatarUrl: props.avatarUrl,
        hasAvatarError: false
      };
    }
    return null;
  }
  private handleAvatarError = (): void => {
    this.setState({
      hasAvatarError: true
    });
  };
  private handleOnClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    const {
      id,
      text,
      onClick,
      isDisabled
    } = this.props;
    if (isDisabled) {
      // Disabled chips do not invoke their click handler.
      return;
    }
    if (onClick) {
      onClick(id, text, e);
    }
  };
  private handleOnMouseEnter = (e: React.MouseEvent<HTMLSpanElement>) => {
    const {
      id,
      text,
      onMouseEnter,
      onHover
    } = this.props;
    if (onMouseEnter) {
      onMouseEnter(id, text, e);
    }
    this.hoverTimeout = window.setTimeout(() => {
      if (onHover) {
        onHover();
      }
      this.hoverTimeout = undefined;
    }, ANALYTICS_HOVER_DELAY);
  };
  private handleOnMouseLeave = (e: React.MouseEvent<HTMLSpanElement>) => {
    const {
      id,
      text,
      onMouseLeave
    } = this.props;
    if (onMouseLeave) {
      onMouseLeave(id, text, e);
    }
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }
  };
  private getMentionType = (): MentionType => {
    const {
      accessLevel,
      isHighlighted,
      isDisabled
    } = this.props;
    if (isDisabled) {
      return MentionType.DISABLED;
    }
    if (isHighlighted) {
      return MentionType.SELF;
    }
    if (isRestricted(accessLevel)) {
      return MentionType.RESTRICTED;
    }
    return MentionType.DEFAULT;
  };
  componentWillUnmount(): void {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }
    const ufoInstance = mentionRenderedUfoExperience.getInstance(this.props.id);
    if ([UFOExperienceState['STARTED'], UFOExperienceState['IN_PROGRESS']].includes(ufoInstance.state)) {
      ufoInstance.abort();
    }
  }
  renderUnknownUserError(id: string): React.JSX.Element {
    return <UnknownUserError values={{
      userId: id.slice(-5)
    }}>
				{message => <>{`@${message}`}</>}
			</UnknownUserError>;
  }
  render(): React.JSX.Element {
    const {
      handleAvatarError,
      handleOnClick,
      handleOnMouseEnter,
      handleOnMouseLeave,
      props
    } = this;
    const {
      appType,
      avatarUrl,
      text,
      id,
      accessLevel,
      localId,
      disabledTooltip,
      isAvatarImagePreShaped,
      renderAvatarSlot,
      isRovoChat
    } = props;
    const mentionType: MentionType = this.getMentionType();
    const failedMention = text === `@${UNKNOWN_USER_ID}`;
    const showAvatarSlot = Boolean(renderAvatarSlot) && !failedMention;
    const visibleText = showAvatarSlot && text.startsWith('@') ? text.slice(1) : text;
    const shouldApplyAgentShape = appType === 'agent' && !isAvatarImagePreShaped;
    const shouldRenderAvatar = avatarUrl && !this.state.hasAvatarError;
    const showRestrictedTooltip = mentionType === MentionType.RESTRICTED;
    const showDisabledTooltip = mentionType === MentionType.DISABLED && !!disabledTooltip;

    // A11y: when the chip is in the disabled visual state, expose
    // `aria-disabled` so assistive tech announces it as such. The
    // disabled-tooltip text is mirrored into `aria-label` so the
    // announcement carries the reason even without portal-id wiring for
    // `aria-describedby`.
    const isDisabledChip = mentionType === MentionType.DISABLED;
    const disabledA11yProps = isDisabledChip ? {
      'aria-disabled': (true as const),
      tabIndex: 0,
      ...(disabledTooltip ? {
        'aria-label': `${text || '@...'} — ${disabledTooltip}`
      } : {})
    } : {};
    const mentionComponent = <FocusRing>
				<PrimitiveMention isAvatarVisible={showAvatarSlot} mentionType={mentionType} onClick={handleOnClick} onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave} spellCheck={false} data-testid={`mention-${id}`} data-mention-type={mentionType} data-mention-tooltip={showRestrictedTooltip || showDisabledTooltip} isRovoChat={isRovoChat} {...disabledA11yProps}>
					{failedMention ? this.renderUnknownUserError(id) : showAvatarSlot ? <>
							<span aria-hidden="true" data-testid="mention-avatar-slot" className={ax(["_4bt5LAnQyn _2WAcuGnQyn _0bjKvDS5Zs _3iDTPbccYA _39xV02R4Xu _0jFU0VR4Xu _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _2xTnZx1Y8M _1RrJLiVdJo", shouldApplyAgentShape && "_0bjKvDdnbC _1uo2ZfnV0Y", this.state.hasAvatarError && "_1RrJLixiOt"])}>
								{shouldRenderAvatar ? <img alt="" decoding="async" draggable={false} height={16} loading="lazy" onError={handleAvatarError} src={avatarUrl} data-testid="mention-avatar" width={16} className={ax(["_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d _00EA0eiObl"])} /> : this.state.hasAvatarError ? '@' : null}
							</span>
							<span>{visibleText || '...'}</span>
						</> : text || '@...'}
				</PrimitiveMention>
			</FocusRing>;
    const ssrPlaceholderProp = props.ssrPlaceholderId ? {
      'data-ssr-placeholder': props.ssrPlaceholderId
    } : {};
    const wrappedMention = (() => {
      if (showRestrictedTooltip) {
        return <React.Suspense fallback={mentionComponent}>
						<AsyncNoAccessTooltip name={text}>{mentionComponent}</AsyncNoAccessTooltip>
					</React.Suspense>;
      }
      if (showDisabledTooltip) {
        return <React.Suspense fallback={mentionComponent}>
						<AsyncDisabledMentionTooltip tooltip={disabledTooltip!}>
							{mentionComponent}
						</AsyncDisabledMentionTooltip>
					</React.Suspense>;
      }
      return mentionComponent;
    })();
    return <UfoErrorBoundary id={id}>
				<span id={localId} data-mention-id={id} data-local-id={localId} data-access-level={accessLevel} spellCheck={false} {...ssrPlaceholderProp}>
					<MessagesIntlProvider>{wrappedMention}</MessagesIntlProvider>
				</span>
			</UfoErrorBoundary>;
  }
}